<div class="shopping-cart-content-header">
  @if (hasEntries && !loading) {
    <h2 class="shopping-cart-content-header-title">{{ entryList.length }} Einträge</h2>
  }
  @if (loading) {
    <h2 class="shopping-cart-content-header-title">Warenkorb wird geladen</h2>
  }
</div>
<div class="shopping-cart-entries-container" [hidden]="!hasEntries">
  <div>
    <p-table
      [value]="entryList"
      [columns]="cols"
      responsiveLayout="scroll"
      scrollHeight="var(--shopping-cart-table-scroll-height)"
      [scrollable]="true"
      (onRowReorder)="rowReordered()"
      #scrollTable
      >
      <ng-template pTemplate="header" let-columns>
        <tr>
          @if (!readonly) {
            <th class="reorder-header">
              <span class="h-offscreen">Einträge mittels drag and drop sortieren</span>
            </th>
          }
          @for (col of columns; track col) {
            <th class="{{ col.scssHeaderClass }}" [attr.aria-label]="col.header">
              <span class="h-offscreen">Spaltentitel</span>{{ col.header }}
            </th>
          }
          @if (!readonly) {
            <th class="action-header" aria-label="Eintrags Aktionen"><span class="h-offscreen">Spaltentitel Eintrags Aktionen</span></th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-index="rowIndex" let-columns="columns">
        <tr
          [id]="rowData.id"
          [appHighlightRow]="index"
          (highlightedRowChanged)="highlightedRowIndex = $event"
          [pReorderableRow]="!readonly ? index : undefined"
          (click)="goToDetailView(rowData['id'])"
          class="table-row"
          [ngClass]="{ 'restricted-entry': rowData.entryError }"
          >
          @if (!readonly) {
            <td class="reorder-icon">
              <span class="reorder-table-icon" aria-hidden="true" pReorderableRowHandle></span>
            </td>
          }
          @for (col of columns; track col) {
            <td class="{{ col.scssColumnClass }}">
              @if (col.type === 'image') {
                <img
                                [src]="
                                    ($any(rowData.keyframeBlob$ | async) | blobToObjectURL) ??
                                    'assets/images/empty-keyframe.svg'
                                "
                  alt="Warenkorbeintrag {{ index + 1 }}"
                  />
                  @if (highlightedRowIndex === index) {
                    <div class="table-entry-number">{{ index + 1 }}</div>
                  }
                  <div class="h-offscreen">
                    Laufzeit {{ getAccessibilityDurationString(rowData["length"]) }}
                  </div>
                  <div class="entry-length" aria-hidden="true">
                    {{ rowData["length"] ? (rowData["length"] | durationFormatPipe) : "-" }}
                  </div>
                }
                @if (col.type === 'text') {
                  <div class="edit-container material-edit-container" data-cy="material-edit-container">
                    @if (readonly) {
                      @for (material of rowData[col.field]; track $index) {
                        <span class="material edit-label">
                          {{ material }}
                        </span>
                      }
                    }
                    @if (!readonly) {
                      @for (material of rowData[col.field]; track $index) {
                        <span
                          class="material edit-label"
                          (click)="openMediaSelection($event, rowData)"
                          >
                          {{ material }}
                        </span>
                      }
                      @if (rowData[col.field].length === 0) {
                        <span
                          (click)="openMediaSelection($event, rowData)"
                          class="no-material-entry"
                          >
                          <img src="assets/icons/arrow-top-right.svg" alt="" class="format-selection-arrow" />Material/Format wählen
                        </span>
                      }
                      @if (highlightedRowIndex === index) {
                        <button
                          class="edit-button"
                          title="Material auswählen"
                          (click)="openMediaSelection($event, rowData)"
                          data-cy="material-edit-button"
                          >
                          <img class="image" src="assets/icons/edit.svg" alt="" />
                        </button>
                      }
                    }
                  </div>
                }
                @if (col.type === 'item') {
                  <a
                    (click)="$event.preventDefault()"
                    class="accessibility-link"
                    (focus)="showActions($event, index)"
                                [href]="
                                    isActiveCart
                                        ? 'shopping-cart/active/' + rowData['id']
                                        : 'shopping-cart/preview/' + cartId + '/' + rowData['id']
                                "
                    >{{ rowData[col.field] }}</a
                    >
                  }
                  @if (col.type === 'inline-edit') {
                    <div class="edit-container remark-edit-container" data-cy="remark-edit-container">
                      @if (isDisplayVisible(index)) {
                        <span class="edit-label">
                          {{ rowData[col.field] }}
                        </span>
                      }
                      @if (isInlineVisible(index)) {
                        <faro-inline-edit-field
                          [iconAltText]="'Vermerk ändern'"
                          [placeholder]="'Text eingeben'"
                          [displayString]="rowData[col.field]"
                          (displayStringChanged)="onEntryNoteChanged($event, rowData.id, index)"
                          (inputFieldFocused)="setFocus(index)"
                          (lostFocus)="resetFocus()"
                          [iconPlacementRight]="true"
                        ></faro-inline-edit-field>
                      }
                    </div>
                  }
                  @if (col.type === 'icon' && hasConstraints(rowData)) {
                    <img
                      src="assets/icons/warning-triangle.svg"
                      alt="Rechtehinweis"
                      tooltipStyleClass="entries-table-tooltip"
                      [pTooltip]="rowData['rightsTooltip']"
                      [escape]="false"
                      />
                      <span class="h-offscreen">{{ rowData["offsetTooltip"] }}</span>
                    }
                  </td>
                }
                @if (!readonly) {
                  <td class="action-icon-td" (click)="showActions($event, index)">
                    @if (highlightedRowIndex !== index) {
                      <button
                        type="button"
                        class="p-table-icon-button"
                        (click)="showActions($event, index)"
                        >
                        <img src="assets/icons/ellipsis.svg" alt="Optionen" />
                      </button>
                    }
                  </td>
                }
                @if (!readonly && highlightedRowIndex === index) {
                  <div
                    class="p-table-action-button-container delete-container"
                    >
                    <button
                      title="Eintrag löschen"
                      pRipple
                      type="button"
                      class="p-table-action-button single-button"
                      id="{{ 'delete-entry-' + index }}"
                      (click)="deleteEntry($event, rowData)"
                      data-cy="delete-shopping-cart-entry-table-button"
                      >
                      <img src="assets/icons/trash-white.svg" alt="" />
                    </button>
                  </div>
                }
              </tr>
              @if (rowData.entryError) {
                <tr class="error-message-row">
                  <td colspan="7" class="error-message-data" aria-hidden="true">{{ rowData.entryError }}</td>
                  <td
                    class="h-offscreen"
                    role="alert"
                    [attr.aria-label]="'Eintrag ' + (index + 1) + rowData.entryError"
                  ></td>
                </tr>
              }
            </ng-template>
          </p-table>
        </div>
      </div>
      @if (!hasEntries && !loading) {
        <app-empty-content [infoText]="'keine Einträge im Warenkorb'"></app-empty-content>
      }
      @if (loading) {
        <div class="loading-container">
          <p-progressSpinner strokeWidth="2" animationDuration="5s" styleClass="custom-spinner"></p-progressSpinner>
        </div>
      }
